export default __webpack_public_path__ + "static/media/Icon awesome-facebook.f2dfa185.svg";